import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Login from "./pages/Login";
import Documentation from "./pages/Documentation";
import Dashboard from "./pages/Dashboard";
import Billing from "./pages/Billing";
import Settings from "./pages/Settings";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import NotFound from "./components/NotFound";
import Menu from "./components/Menu";
import { verifyMe } from "./store/actions/authActions";
import "./styles/custom.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import "./i18n/i18n"; // Import the i18n configuration
import i18n from "./i18n/i18n";
const LOCAL_STORAGE_KEY_LANG = "lang";
const theme = createTheme({
  palette: {
    primary: {
      main: "#222430", // Your custom primary color
    },
    secondary: {
      main: "#ffffff", // Your custom secondary color
    },
    error: {
      main: "#FB2B44",
    },
    warning: {
      main: "#ff9800",
    },
    info: {
      main: "#2196f3",
    },
    success: {
      main: "#4caf50",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    h1: {
      fontSize: "2rem",
    },
    // Customize typography if needed
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none", // Example customization
        },
      },
    },
  },
});

const AppContent = () => {
  // const location = useLocation();
  // const hideMenu = location.pathname === "/"; // Hide Menu on the login page
  
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { isGlobalLoader } = useSelector((state) => state.loader);
  const hideMenu = !isAuthenticated;// Hide Menu if not logged in

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(verifyMe());
    const lang = localStorage.getItem(LOCAL_STORAGE_KEY_LANG);
    lang ? i18n.changeLanguage(lang) : void 0;
  }, [dispatch]);
  if (isGlobalLoader) {
    return (
      <div className="global-loader">
        <img src="../assets/ripples.svg" alt="Loading..." />
      </div>
    );
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <>
        {!hideMenu && <Menu />}
        <Routes>
          <Route
            path="/"
            element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
          />
          <>
            <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
            <Route path="/billing" element={<PrivateRoute element={<Billing />} />} />
            <Route path="/settings" element={<PrivateRoute element={<Settings />} />} />
          </>
          <Route path="/documentation" element={<PublicRoute element={<Documentation />} />} />
          {/* Catch-all 404 route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </>
    </ThemeProvider>
  );
};
const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
